/**
 * 扩展 ant design Icon 组件, 支持自定义的字体
 */
import {Component} from 'react'
import Icon from '@ant-design/icons'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './index.less'

function getHZComponent(name) {
    try {
        return require(`assets/menu-icons/${name}`).default
    } catch (e) {
        return null
    }
}

export default class HzIcon extends Component {
    static propTypes = {
        type: PropTypes.string.isRequired,
    }

    render() {
        const {type, className = '', ...other} = this.props
        if (type.indexOf('HZ-') === 0) {
            const cls = classNames(styles.icon, className)
            const component = getHZComponent(type.slice(3))
            if (component) {
                return <Icon component={component} className={cls} {...other} />
            }
            return null
        }

        return <Icon {...this.props} />
    }
}
